import CollectionList       from '@/js/Shared/Collections/CollectionList';
import ContactPersonItem    from '../Entities/ContactPersonItem';

export {ContactsRecipientsCollection as default};

/**
* Contacts Boxes Collectiin
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContactsRecipientsCollection extends CollectionList {
  /**
   * Contacts Collection Lists data
   *
   * @private
   *
   * @since 7.0.0
   *
   * @type {ContactsCollectionLists}
   */
  contacts;

  /**
   * Creates an object associating the Recipient's Index
   * with the ContactPersonItem
   *
   * @type {Object.<ContactPersonItem>}
   */
  cache_array_index = {};

  /**
   * Creates an object associating the Contact Person ID
   * with the Index of the Array recipient
   *
   * @type {Object.<Number>}
   */
  cache_id_index = {}

  constructor() {
    super('id');
  }

 /**
   * Sets contacts collection data
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {ContactsCollectionLists} contacts Contacts collection lists
   *
   * @return {void}
   */
  setContacts(contacts) {
    this.contacts = contacts;
  }

  /**
   * Adiciona um contato na collection
   *
   * @param {Object.<ContactPersonItem>} person
   *
   * @param {Number} index posição do array do recipients
   *
   * @returns {void}
   */
  add(person, index){
    super.add(person);

    this.cache_array_index[index] = person;
    this.cache_id_index[person.id] = index;
  }

  /**
   * Remove a contact from the collection
   *
   * @param {String} id
   *
   * @returns {void}
   */
  delete(id){
    super.delete(id);

    const recipient_array_index = this.cache_id_index[id];
    delete this.cache_id_index[id];
    delete this.cache_array_index[recipient_array_index];
  }

  /**
   * Add contact through an array
   *
   * @param {Array} recipients
   */
  addPersonByArray(recipients){
    recipients.forEach((recipient, recipient_index) => {
      let person = this.getExistingContact(recipient);

      if (!person) {
        person           = new ContactPersonItem();
        person.id        = Math.random().toString(18);
        person.name      = recipient.name || recipient.email;
        person.email     = recipient.email;
        person.recipient = recipient.email;
        person.temporary = true;
      }

      this.add(person, recipient_index);
    });
  }

  /**
   * Verifica e pega se existe um contato na lista
   * do utilizador
   *
   * @param {Object.<MessageRecipientItem>} contact
   *
   * @returns {Object.<ContactPersonItem>|null}
   */
  getExistingContact(contact) {
    const email = this.stringFormatted(contact.email);
    const name  = this.stringFormatted(contact.name);

    const person = this.findPersonByNameAndEmail(name,email);

    if (!person) {
      return this.findPersonByEmail(email);
    }

    return person;
  }

  /**
   * Procura um contato na lista usando o nome e email como criterios
   *
   * @param {String} name
   *
   * @param {String} email
   *
   * @returns {Object.<ContactPersonItem>}
   */
  findPersonByNameAndEmail(name, email) {
    return this.contacts.persons.items.find(
      contact => this.stringFormatted(contact.name) === name
        && this.stringFormatted(contact.email) === email
    );
  }

  /**
   * Procura um contato na lista usando o email como criterio
   *
   * @param {String} email
   *
   * @returns {Object.<ContactPersonItem>}
   */
  findPersonByEmail(email){
    return this.contacts.persons.items.find(
      contact => contact.email && this.stringFormatted(contact.email) === email
    );
  }

  /**
   * Formats a string using lower case, latineze and trim
   *
   * @param {String} value
   *
   * @returns {String}
   */
  stringFormatted(value){
    if(value){
      value = value.toLowerCase().latinize().trim();
    }

    return value;
  }

  /**
   * Resets the collection values
   *
   * @returns {void}
   */
  reset(){
    this.contacts = {};
    this.cache_id_index = {};
    this.cache_array_index = {};
    super.reset();
  }
}